module.exports = __webpack_public_path__ + "media/images/riders/small/FLORENT_PAYET-05e4ef9e0b37c3317b1d209d98dfe348.png";